// src/IntakePrompt.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function IntakePrompt() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-4">
      <div className="card flex w-full max-w-lg flex-col gap-6 p-10 text-center">
        <h1 className="font-display text-3xl font-semibold text-ink">
          What would you like to do?
        </h1>

        <p className="text-ink-muted">
          First, let us know what courses you've taken. You can manually input your
          prior courses using the dropdown on the next screen.
        </p>

        <button
          onClick={() => navigate("/intake")}
          className="btn-primary btn-lg mx-auto w-full sm:w-auto"
        >
          Manually input courses
        </button>
      </div>
    </div>
  );
}
